const renderLogo = (logoImage, logoSize, onClick) => (
  <div>
    <a href="/" onClick={onClick}>
      <img
        style={{ display: "block", padding: "15px 0" }}
        alt="logo"
        src={logoImage}
        height={logoSize}
      />
    </a>
  </div>
)

export const theme = (franchiseTheme) => ({
  // flossie default theme

  // Max width for page as a whole, primarily affecting header/navigation
  pageMaxWidth: "none",

  // Max width for instant book listings on the home page
  instantBookMaxWidth: "800px",

  logoSize: 70,
  logo: renderLogo,

  wwwBgColor: "#676767",
  wwwBgImagePosition: "center center",
  wwwBgImagePositionMobile: "center center",

  sectionDividerColor: "rgba(250,200,205,0.6)",

  ...franchiseTheme, // franchise override

  colors: {
    primary: "#EF609F", // For brand module button fills, accents: eg star ratings - use when appearing on white background (ie #FFFFFF)
    primaryAccent: "#FFF",

    secondary: "#EF609F", // For utility nav, button fill and outlines, icons, text
    secondaryAccent: "#FFF",

    tertiary: "#ECECEC", // For rollover product panels, and module backgrounds as needed

    accent: "#EF609F", // For accents like discounts, etc.
    error: "#BC3C3C", // For error messages

    disabled: "#e2e2e2",
    disabledAccent: "#FFF",

    inactive: "#CCC",
    headers: "#444444",
    lightHover: "#EF609F11",
    darkHover: "#EDEAE3",

    overlayColor: "rgba(250,200,205,0.6)",

    price: "#EF609F",

    ...(franchiseTheme.colors ? franchiseTheme.colors : {}),
  },
  topNav: {
    background: "#444444",
    links: "#FFF",
    icons: "#000",
    whatWhenWhereText: "#FFF",

    ...(franchiseTheme.topNav ? franchiseTheme.topNav : {}),
  },
  sideNav: {
    alignment: "right",
    top: "70px",
    background: "#575757",
    links: "#FFF",
    activeLinks: "#EF609F",
    legalLinks: "#CCC",
    ...(franchiseTheme.sideNav ? franchiseTheme.sideNav : {}),
  },
  dateSelector: {
    defaultText: "#000",
    disabledText: "#CCC",
    saleText: "#EF609F",
    selectedText: "#fff",
    selectedBackground: "#444",
    ...(franchiseTheme.dateSelector ? franchiseTheme.dateSelector : {}),
  },
  timeSelector: {
    defaultText: "#000",
    selectedText: "#FFF",
    selectedBackground: "#444",
    hoverText: "#000",
    hoverBackground: "#FFF",
    ...(franchiseTheme.timeSelector ? franchiseTheme.timeSelector : {}),
  },
  button: {
    borderRadius: "30px",
    borderWidth: "2px",
    textTransform: "none",
    letterSpacing: "0px",
    fontWeight: 700,
    fontSizeSmall: "13px",
    fontSizeLarge: "16px",
    ...(franchiseTheme.button ? franchiseTheme.button : {}),
  },
  paymentMethod: {
    backgroundColor: "#ef609f",
    headerText: "#fff",
    ...(franchiseTheme.paymentMethod ? franchiseTheme.paymentMethod : {}),
  },
  poweredByFlossie: {
    backgroundColor: "#ef609f",
    text: "#fff",
    ...(franchiseTheme.poweredByFlossie ? franchiseTheme.poweredByFlossie : {}),
  },
  responsive: {
    mobile: 768,

    // Defined in redux/rootReducer.js by redux-responsive
    extraSmall: "(max-width: 480px)",
    small: "(max-width: 768px)",
    medium: "(max-width: 992px)",
    large: "(max-width: 1200px)",
  },
})
